/**
 * @voltxampere/ui — DPDT toggle switch variant (Sprint 44-3, placeholder)
 *
 * PLACEHOLDER. Double-Pole Double-Throw mechanical toggle —
 * 6 terminal (2× SPDT in tandem). Şu anki stamp tek 2-terminal
 * `switch` üzerinden modellenir; gerçek 6-pin DPDT engine
 * extension #4 ile (Sprint 47+'da) iki bağımsız `switch`
 * instance + interlock ile.
 *
 * Reference: Generic DPDT toggle (e.g. C&K 7200 series, NKK
 * S-series). 3-6 A @ 125 VAC. H-bridge polarite tersleme + dual
 * channel ses çıkış seçici + güç dağıtım.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const switchDpdt = {
    id: "switch-dpdt",
    nameTr: "DPDT Toggle (6 terminal, placeholder)",
    nameEn: "DPDT Toggle (6 terminal, placeholder)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "SW",
    defaultValue: "DPDT",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=switch-dpdt.js.map